/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IKeyCombinationListItem } from "../keyBinding/IKeyBinding";
import { KEY_CODE } from "../keyBinding/KeyCodeMap";

export const CommonKeyCombinations = {
	toggleLeftPanel: [
		{
			isMac: false,
			isLinux: true,
			isWin: true,
			key: {
				ctrlKey: false,
				metaKey: false,
				shiftKey: false,
				altKey: true,
				keyCode: KEY_CODE.KEY_1
			}
		},
		{
			isMac: true,
			isLinux: false,
			isWin: false,
			key: {
				ctrlKey: true,
				metaKey: false,
				shiftKey: false,
				altKey: false,
				keyCode: KEY_CODE.KEY_1
			}
		}
	] as IKeyCombinationListItem[],
	toggleRightPanel: [
		{
			isMac: false,
			isLinux: true,
			isWin: true,
			key: {
				ctrlKey: false,
				metaKey: false,
				shiftKey: false,
				altKey: true,
				keyCode: KEY_CODE.KEY_2
			}
		},
		{
			isMac: true,
			isLinux: false,
			isWin: false,
			key: {
				ctrlKey: true,
				metaKey: false,
				shiftKey: false,
				altKey: false,
				keyCode: KEY_CODE.KEY_2
			}
		}
	] as IKeyCombinationListItem[],
	undo: [
		{
			isMac: false,
			isLinux: true,
			isWin: true,
			key: {
				ctrlKey: true,
				metaKey: false,
				shiftKey: false,
				altKey: false,
				keyCode: KEY_CODE.KEY_Z
			}
		},
		{
			isMac: true,
			isLinux: false,
			isWin: false,
			key: {
				ctrlKey: false,
				metaKey: true,
				shiftKey: false,
				altKey: false,
				keyCode: KEY_CODE.KEY_Z
			}
		}
	] as IKeyCombinationListItem[],
	redo: [
		{
			isMac: false,
			isLinux: true,
			isWin: true,
			key: {
				ctrlKey: true,
				metaKey: false,
				shiftKey: true,
				altKey: false,
				keyCode: KEY_CODE.KEY_Z
			}
		},
		{
			isMac: true,
			isLinux: false,
			isWin: false,
			key: {
				ctrlKey: false,
				metaKey: true,
				shiftKey: true,
				altKey: false,
				keyCode: KEY_CODE.KEY_Z
			}
		}
	] as IKeyCombinationListItem[],
	hideAllPanels: [
		{
			isMac: false,
			isLinux: true,
			isWin: true,
			key: {
				ctrlKey: false,
				metaKey: false,
				shiftKey: false,
				altKey: true,
				keyCode: KEY_CODE.KEY_3
			}
		},
		{
			isMac: true,
			isLinux: false,
			isWin: false,
			key: {
				ctrlKey: true,
				metaKey: false,
				shiftKey: false,
				altKey: false,
				keyCode: KEY_CODE.KEY_3
			}
		}
	] as IKeyCombinationListItem[],
	toggleConsole: [
		{
			isMac: false,
			isLinux: true,
			isWin: true,
			key: {
				ctrlKey: false,
				metaKey: false,
				shiftKey: false,
				altKey: true,
				keyCode: KEY_CODE.KEY_Q
			}
		},
		{
			isMac: true,
			isLinux: false,
			isWin: false,
			key: {
				ctrlKey: true,
				metaKey: false,
				shiftKey: false,
				altKey: false,
				keyCode: KEY_CODE.KEY_Q
			}
		}
	] as IKeyCombinationListItem[],
	copy: [
		{
			key: {
				ctrlKey: true,
				altKey: false,
				shiftKey: false,
				metaKey: false,
				keyCode: KEY_CODE.KEY_C
			},
			isWin: true,
			isLinux: true,
			isMac: false
		},
		{
			key: {
				ctrlKey: false,
				altKey: false,
				shiftKey: false,
				metaKey: true,
				keyCode: KEY_CODE.KEY_C
			},
			isWin: false,
			isLinux: false,
			isMac: true
		}
	] as IKeyCombinationListItem[],
	paste: [
		{
			key: {
				ctrlKey: true,
				altKey: false,
				shiftKey: false,
				metaKey: false,
				keyCode: KEY_CODE.KEY_V
			},
			isWin: true,
			isLinux: true,
			isMac: false
		},
		{
			key: {
				ctrlKey: false,
				altKey: false,
				shiftKey: false,
				metaKey: true,
				keyCode: KEY_CODE.KEY_V
			},
			isWin: false,
			isLinux: false,
			isMac: true
		}
	] as IKeyCombinationListItem[],
	save: [
		{
			key: {
				ctrlKey: true,
				altKey: false,
				shiftKey: false,
				metaKey: false,
				keyCode: KEY_CODE.KEY_S
			},
			isWin: true,
			isLinux: true,
			isMac: false
		},
		{
			key: {
				ctrlKey: false,
				altKey: false,
				shiftKey: false,
				metaKey: true,
				keyCode: KEY_CODE.KEY_S
			},
			isWin: false,
			isLinux: false,
			isMac: true
		}
	] as IKeyCombinationListItem[],
	delete: [
		{
			key: {
				ctrlKey: false,
				altKey: false,
				shiftKey: false,
				metaKey: false,
				keyCode: KEY_CODE.Delete
			},
			isWin: true,
			isLinux: true,
			isMac: true
		}
	] as IKeyCombinationListItem[],
	escape: [
		{
			key: {
				ctrlKey: false,
				altKey: false,
				shiftKey: false,
				metaKey: false,
				keyCode: KEY_CODE.Escape
			},
			isWin: true,
			isLinux: true,
			isMac: true
		}
	] as IKeyCombinationListItem[]
};
